<template>
  <ContentWrap>
    <el-alert
      class="mb-12px"
      type="info"
      :closable="false"
      title="三角对账最小可读版：配送费合计 ↔ 骑手入账 ↔ 机构分润；差额近似平台费。"
    />

    <el-button class="mb-12px" type="primary" @click="load">刷新对账</el-button>

    <el-row :gutter="16" v-if="view">
      <el-col :span="6">
        <el-card shadow="never">
          <div class="text-13px text-[var(--el-text-color-secondary)]">配送费合计</div>
          <div class="text-22px font-600 mt-4px">¥{{ view.externalFeeTotal }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never">
          <div class="text-13px text-[var(--el-text-color-secondary)]">骑手入账合计</div>
          <div class="text-22px font-600 mt-4px">¥{{ view.riderCreditTotal }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never">
          <div class="text-13px text-[var(--el-text-color-secondary)]">机构分润合计</div>
          <div class="text-22px font-600 mt-4px">¥{{ view.orgCommissionTotal }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never">
          <div class="text-13px text-[var(--el-text-color-secondary)]">平台费（推算）</div>
          <div class="text-22px font-600 mt-4px">¥{{ view.platformFeeTotal }}</div>
        </el-card>
      </el-col>
    </el-row>

    <p v-if="view" class="mt-16px text-13px text-[var(--el-text-color-secondary)]">
      {{ view.residualHint }}
    </p>
  </ContentWrap>
</template>

<script lang="ts" setup>
import * as WalletApi from '@/api/capacity/wallet'
import { ContentWrap } from '@/components/ContentWrap'

defineOptions({ name: 'CapacityReconcileDemo' })

const view = ref<WalletApi.ReconcileView>()

const load = async () => {
  view.value = await WalletApi.reconcile()
}

onMounted(load)
</script>
